module.exports = __webpack_public_path__ + "img/img-3.556f257f.png";